






















import { Component, Vue } from 'vue-property-decorator'

import config from '@/config'
import Cookie from 'js-cookie'

@Component
export default class CookiePolicy extends Vue {
	private isHidden: boolean = false
	private readonly cookiePolicyLabel: string = config.cookiePolicy

	acceptPolicy() {
		Cookie.set('cookiePolicyAccepted', 'true')
		this.isHidden = true
	}
}
